import { makeStyles } from '@material-ui/core/styles';

// Match the existing dense dispatch map, not a separate visual system.
export const useStyles = makeStyles((theme) => ({
  frame: {
    position: 'fixed', zIndex: 1201, display: 'flex', justifyContent: 'flex-end',
    gap: 4, padding: 4, boxSizing: 'border-box',
    background: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`, borderRadius: 6,
    boxShadow: theme.shadows[3],
    '& > button': { textTransform: 'none', minHeight: 32 },
  },
  panel: {
    position: 'absolute', right: -1, bottom: 'calc(100% + 5px)',
    width: 440, maxWidth: 'var(--map-control-width)',
    height: 'min(570px, var(--map-control-height))',
    overflow: 'hidden', borderRadius: 6,
    '&[hidden]': { display: 'none' },
    boxShadow: theme.shadows[4], background: theme.palette.background.paper,
    '& > *': {
      position: 'static', width: '100%', maxWidth: '100%', height: '100%',
      maxHeight: '100%', boxSizing: 'border-box', margin: 0,
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%', borderRadius: '8px 8px 0 0',
    },
  },
}));
